import React from 'react';
import FastImage from 'react-native-fast-image';
import Theme from '../../../theme';

const colourIcons = {
    [Theme.WHITE]: require('../../../assets/images/logo-white-star.png'),
    [Theme.BLACK]: require('../../../assets/images/fitbeat-star.png'),
    [Theme.GREY]: require('../../../assets/images/logo-grey-star.png'),
    // todo: Grey dark is a grey image without transparency and is not related to the color GREY_DARK. Fix this inconsistency
    [Theme.GREY_DARK]: require('../../../assets/images/logo-grey-solid-star.png'),
}

export const FitbeatIcon = ({
                                color = Theme.BLACK,
                                width,
                                height,
                                style,
                            }) => (
    <FastImage
        resizeMode='contain'
        style={{
            width,
            height,
            ...style,
        }}
        source={colourIcons[color]}
    />
);
